import { Pipe, PipeTransform } from '@angular/core';
import { getChildParam } from '@core/utils/get-child-param';

@Pipe({
    standalone: true,
    name: 'viewParam',
})
export class ViewParamPipe implements PipeTransform {
    public transform(item: any, viewParam: string): any {
        if (item && viewParam) {
            return getChildParam(item, viewParam);
        }

        return item;
    }
}
